import React, { useState } from 'react';
import './AlphaNum.css';

const alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
const numbers = Array.from({ length: 10 }, (_, i) => i + 1);
const words = ['hello', 'world', 'react', 'javascript', 'coding', 'example', 'voice', 'select', 'option', 'button'];

const images = {
  A: './images/c1.jpg', // Replace with actual image paths
  B: 'path/to/imageB.jpg',
  // Add images for each alphabet
  1: './images/c2.png',
  2: 'path/to/image2.jpg',
  // Add images for each number
  hello: 'path/to/hello.jpg',
  world: './images/c3.png',
  // Add images for each word
};

const AlphaNum = () => {
  const [mode, setMode] = useState('alphabets');
  const [selectedItem, setSelectedItem] = useState(null);

  const speak = (text) => {
    const msg = new SpeechSynthesisUtterance(text);
    window.speechSynthesis.speak(msg);
  };

  const handleClick = (item) => {
    speak(item);
    setSelectedItem(item);
  };

  const getImageSrc = (item) => {
    return images[item] || 'https://via.placeholder.com/150';
  };

  return (
    <div className="AppAN">
      <h1>Select to Display Alphabets, Numbers, or Words</h1>
      <div className="select-container">
        <select onChange={(e) => setMode(e.target.value)} className="select">
          <option value="alphabets">Alphabets</option>
          <option value="numbers">Numbers</option>
          <option value="words">Words</option>
        </select>
      </div>
      <div className="container">
        {mode === 'alphabets' && (
          <div className="alphabets">
            {alphabets.map((letter) => (
              <button key={letter} onClick={() => handleClick(letter)} className="button">
                {letter}
              </button>
            ))}
          </div>
        )}
        {mode === 'numbers' && (
          <div className="numbers">
            {numbers.map((number) => (
              <button key={number} onClick={() => handleClick(number)} className="button">
                {number}
              </button>
            ))}
          </div>
        )}
        {mode === 'words' && (
          <div className="words">
            {words.map((word) => (
              <button key={word} onClick={() => handleClick(word)} className="button">
                {word}
              </button>
            ))}
          </div>
        )}
        {selectedItem && (
          <div className="image-display">
            <img src={getImageSrc(selectedItem)} alt={selectedItem} />
          </div>
        )}
      </div>
    </div>
  );
};

export default AlphaNum;
